var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',{staticStyle:{"padding-left":"50px","padding-right":"50px","padding-top":"10px","padding-bottom":"10px"}},[_vm._v("\n  TODO\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }